import { Button, Radio, CloseIcon, Drawer, Text, Input } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import styles from './drawer-filter.module.css'

import { ConversationDrawerFilterProps } from './drawer-filter.type'
import { IAConversationRoleEnum } from '@/types'

export const ConversationDrawerFilter = ({
  isOpen,
  onHandleOpen,
  filter,
  onHandleFilter,
}: ConversationDrawerFilterProps) => {
  const { t } = useTranslation('screenAiCenter')
  const { t: tEnums } = useTranslation('enums')

  const onChangeValue = (key: string, value: string) => {
    onHandleFilter({ ...filter, [key]: value })
  }
  return (
    <Drawer isOpen={isOpen} onHandleOpen={onHandleOpen}>
      <div className={styles.header}>
        <Text variant="title-large" className={styles['header-title']}>
          {t('conversationTableFilterTitle')}
        </Text>

        <button
          className={styles['header-button']}
          type="button"
          onClick={onHandleOpen}
        >
          <CloseIcon />
        </button>
      </div>

      <div className={styles.content}>
        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('conversationTableFilterIsNotificationOnly')}
          </Text>

          <Radio
            value={filter.isNotificationOnly === ''}
            onChange={() => onChangeValue('isNotificationOnly', '')}
          >
            {t('conversationTableFilterIsNotificationOnlyAll')}
          </Radio>

          <Radio
            value={filter.isNotificationOnly === 'true'}
            onChange={() => onChangeValue('isNotificationOnly', 'true')}
          >
            {t('conversationTableFilterIsNotificationOnlyYes')}
          </Radio>

          <Radio
            value={filter.isNotificationOnly === 'false'}
            onChange={() => onChangeValue('isNotificationOnly', 'false')}
          >
            {t('conversationTableFilterIsNotificationOnlyNo')}
          </Radio>
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">{t('conversationTableFilterRole')}</Text>

          <div className={styles['content-filter-group-options']}>
            <Radio
              value={filter.role === ''}
              onChange={() => onChangeValue('role', '')}
            >
              {t('conversationTableFilterRoleAll')}
            </Radio>

            {Object.values(IAConversationRoleEnum).map((role) => (
              <Radio
                key={role}
                value={filter.role === role}
                onChange={() => onChangeValue('role', role)}
              >
                {tEnums(`conversation_role_${role}`)}
              </Radio>
            ))}
          </div>
        </div>

        <div className={styles['content-filter']}>
          <Text variant="title-base">
            {t('conversationTableFilterRfqSearch')}
          </Text>

          <div className={styles['content-filter-group-options']}>
            <Input
              value={filter.rfqReference}
              onChange={(value) => onChangeValue('rfqReference', value)}
            />
          </div>
        </div>
      </div>

      <div className={styles.footer}>
        <Button variant="secondary" onClick={onHandleOpen}>
          {t('conversationTableFilterButtonBack')}
        </Button>
      </div>
    </Drawer>
  )
}
